import React from 'react'
import cx from 'classnames'
import moment from 'moment'
import { Message } from 'sb-react-intl'

import Icon, { IconColor } from 'components/_new/ui/Icon/Icon'

import s from './DeliveryStatus.scss'
import messages from './messages'


const getDeliveryDateMessage = ({ deliveryDate, monthOnly }) => {
  let month
  let year

  if (typeof deliveryDate === 'object') {
    if (deliveryDate.year) {
      month = moment.monthsShort()[deliveryDate.month - 1] // Jan
      year  = deliveryDate.year // eslint-disable-line
    }
    else {
      month = moment.months()[deliveryDate.month - 1] // January
    }
  }
  else if (deliveryDate) {
    month = moment(deliveryDate).format(monthOnly ? 'MMMM' : 'MMM')

    if (!monthOnly) {
      year = moment(deliveryDate).format('YYYY')
    }
  }

  return `${month}${year ? ` ${year}` : ''}`
}

export const deliveryStates = [ 'processing', 'onTheWay', 'delivered' ] as const

export type DeliveryState = typeof deliveryStates[number]

// TODO looks weird that we can pass multiple types - added on 3/25/20 by pavelivanov
// milliseconds - 1553450651862
// ISO string - 2019-12-24T18:05:48.123Z
export type DeliveryDate = { month: number, year?: number } | number | string

export type DeliveryStatusProps = {
  className?: string
  color?: 'brand' | 'gray'
  monthOnly?: boolean
  textOnly?: boolean
  uppercase?: boolean // TODO get rid of "uppercase" or make default value of "false" - added on 3/25/20 by pavelivanov
} & AtLeastOne<{
  state: DeliveryState
  deliveryDate: DeliveryDate
}>

const DeliveryStatus: React.FunctionComponent<DeliveryStatusProps> = (props) => {
  let { className, color = 'brand', state: propState, deliveryDate, monthOnly, textOnly, uppercase = true } = props
  let state: DeliveryState | 'arrivesIn'

  if (deliveryDate) {
    state = 'arrivesIn'
  }
  else {
    state = propState
  }

  const deliveryDateMessage = deliveryDate ? getDeliveryDateMessage({ deliveryDate, monthOnly }) : ''

  const textClassName = cx(s.text, s[`${color}Color`], {
    [s.uppercase]: uppercase,
  })

  if (textOnly) {
    return (
      <div className={cx(textClassName, className)}>
        <Message text={messages[state]} /> {deliveryDateMessage ? <b>{deliveryDateMessage}</b> : ''}
      </div>
    )
  }

  return (
    <div className={cx(s.deliveryStatus, className)}>
      <Icon className={s.truckIcon} name="truck" color={color as IconColor} />
      <span className={textClassName}>
        <Message text={messages[state]} /> {deliveryDateMessage ? <b>{deliveryDateMessage}</b> : ''}
      </span>
    </div>
  )
}


export default DeliveryStatus
